// extracted by mini-css-extract-plugin
module.exports = {"toggle_container":"Toggle_toggle_container__3zODN","toggle_value":"Toggle_toggle_value__3tbdZ","selected":"Toggle_selected__3_oQU"};